export const map = (v: number, s0: number, s1: number, e0: number, e1: number): number => e0 + (v - s0) / (s1 - s0) * (e1 - e0);
export const mapClamped = (v: number, s0: number, s1: number, e0: number, e1: number): number => clamp( e0 + (v - s0) / (s1 - s0) * (e1 - e0),Math.min(e0,e1), Math.max(e0,e1));

export const len = (x: number, y: number): number => Math.sqrt(x * x + y * y)
export const dist = (x1: number, y1: number, x2: number, y2: number): number => len(x1 - x2, y1 - y2)
export const lerp = (v1: number, v2: number, t): number => v1 + (v2 - v1) * t
export const invLerp = (v1: number, v2: number, t): number => (t - v1) / (v2 - v1)
export const clamp = (v: number, min: number, max: number): number => Math.min(max, Math.max(v, min))
export const clamp01 = (x: number): number => clamp(x, 0, 1)
export const mod = (n: number, m: number): number => ((n % m) + m) % m;

export const lerpAngle = (v1: number, v2: number, t: number): number => {
    let diff = mod(v2 - v1, Math.PI * 2)
    if (diff > Math.PI)
        diff -= Math.PI * 2

    return v1 + diff * t
}

export const moveTowardsAngle = (a1: number, a2: number, maxChange: number): number => {

    return a1 + clamp(deltaAngle(a1, a2), -maxChange, maxChange)
}
export const moveTowards = (a1: number, a2: number, maxChange: number): number => {

    return a1 + clamp(a2 - a1, -maxChange, maxChange)
}

export const deltaAngle = (a1: number, a2: number): number => {
    let diff = mod(a2 - a1, Math.PI * 2)
    if (diff > Math.PI)
        diff -= Math.PI * 2

    return diff;
}